import { WarningIcon } from '@repo/icons';
import { cn } from '@repo/utils/cn';

type NoDataProps = {
  title?: string;
  subTitle?: string;
  className?: string;
  dataTestId?: string;
};

const NoData = ({ title, subTitle, className, dataTestId }: NoDataProps) => {
  return (
    <div
      className={cn('vt-surface-light-bg flex w-full flex-col items-center justify-center space-y-1.5', className)}
      data-testid={dataTestId || 'no-data-title'}
    >
      <WarningIcon className="h-6 w-6" />
      <span className="vt-font-highlight-font-family vt-headings-text vt-text-size-medium sm:vt-text-size-medium-sm">
        {title}
      </span>
      <span className="vt-text-size-small sm:vt-text-size-small-sm text-center">{subTitle}</span>
    </div>
  );
};

export { NoData };
